import React from 'react';
import { Portal } from 'bringg-web/components';
import { FleetsConfiguration } from './fleets-configuration';

export const FleetsConfigurationPortal = () => {
	return <Portal element={<FleetsConfiguration />} nodeId="fleets-configuration-portal" />;
};
